import React from 'react';

interface ActionsBarProps {
  onOpenDeposit: () => void;
  onOpenCharge: () => void;
  depositLabel: string;
  chargeLabel: string;
}

const ActionsBar: React.FC<ActionsBarProps> = ({
  onOpenDeposit,
  onOpenCharge,
  depositLabel,
  chargeLabel,
}) => {
  return (
    <div className="flex gap-3 mb-6">
      <button
        onClick={onOpenDeposit}
        className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white px-4 py-2 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-200 text-sm"
      >
        {depositLabel}
      </button>
      <button
        onClick={onOpenCharge}
        className="flex-1 bg-gradient-to-r from-red-600 to-pink-600 text-white px-4 py-2 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-200 text-sm"
      >
        {chargeLabel}
      </button>
    </div>
  );
};

export default ActionsBar;
